/**
 * Carousel popup — click-triggered modal with metaobject-driven items.
 * Opens via configurable CSS class (data-trigger-class on each popup root).
 */
(function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 768px)');
  var PAGE_SIZE = 4;
  var instances = [];

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function PopupCarousel(root) {
    this.root = root;
    this.triggerClass = (root.getAttribute('data-trigger-class') || 'popup-carousel-trigger-cylinders').trim();
    this.detailMode = (root.getAttribute('data-detail-mode') || 'associated_product').trim();
    this.detailHeadingPattern = root.getAttribute('data-detail-heading-pattern') || '{machine} works with';
    this.dialog = root.querySelector('[data-jsc-pc-dialog]');
    this.track = root.querySelector('[data-jsc-pc-track]');
    this.dotsEl = root.querySelector('[data-jsc-pc-dots]');
    this.prevBtn = root.querySelector('[data-jsc-pc-prev]');
    this.nextBtn = root.querySelector('[data-jsc-pc-next]');
    this.carouselView = root.querySelector('[data-jsc-pc-view="carousel"]');
    this.detailView = root.querySelector('[data-jsc-pc-view="detail"]');
    this.detailTitle = root.querySelector('[data-jsc-pc-detail-title]');
    this.detailImage = root.querySelector('[data-jsc-pc-detail-image]');
    this.detailImageWrap = root.querySelector('[data-jsc-pc-detail-image-wrap]');
    this.bottleList = root.querySelector('[data-jsc-pc-bottle-list]');
    this.bottleEmpty = root.querySelector('[data-jsc-pc-bottle-empty]');
    this.cta = root.querySelector('[data-jsc-pc-cta]');
    this.items = Array.prototype.slice.call(root.querySelectorAll('[data-jsc-pc-item]'));
    this.isOpen = false;
    this.lastTrigger = null;
    this.pageIndex = 0;
    this.boundKeydown = this.onKeydown.bind(this);
    this.boundFocusIn = this.onFocusIn.bind(this);
    this.scrollRaf = null;

    this.bind();
    this.buildDots();
    this.syncNav();
  }

  PopupCarousel.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-jsc-pc-close]')) {
        e.preventDefault();
        self.close();
        return;
      }

      var selectBtn = e.target.closest('[data-jsc-pc-select]');
      if (selectBtn && self.root.contains(selectBtn)) {
        e.preventDefault();
        self.showDetail(selectBtn);
        return;
      }

      if (e.target.closest('[data-jsc-pc-back]')) {
        e.preventDefault();
        self.showCarousel();
        return;
      }

      if (e.target.closest('[data-jsc-pc-prev]')) {
        e.preventDefault();
        self.goPage(-1);
        return;
      }

      if (e.target.closest('[data-jsc-pc-next]')) {
        e.preventDefault();
        self.goPage(1);
        return;
      }

      var dot = e.target.closest('[data-jsc-pc-dot]');
      if (dot && self.dotsEl && self.dotsEl.contains(dot)) {
        e.preventDefault();
        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(index)) self.scrollToItem(index, true);
      }
    });

    if (this.track) {
      this.track.addEventListener('scroll', function () {
        if (self.scrollRaf) return;
        self.scrollRaf = window.requestAnimationFrame(function () {
          self.scrollRaf = null;
          self.onTrackScroll();
        });
      }, { passive: true });
    }

    if (typeof DESKTOP_MQ.addEventListener === 'function') {
      DESKTOP_MQ.addEventListener('change', function () {
        self.buildDots();
        self.syncNav();
      });
    } else if (typeof DESKTOP_MQ.addListener === 'function') {
      DESKTOP_MQ.addListener(function () {
        self.buildDots();
        self.syncNav();
      });
    }
  };

  PopupCarousel.prototype.getFocusable = function () {
    if (!this.dialog) return [];
    var selector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.prototype.slice.call(this.dialog.querySelectorAll(selector)).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  };

  PopupCarousel.prototype.onKeydown = function (e) {
    if (!this.isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = this.getFocusable();
    if (!focusable.length) {
      e.preventDefault();
      if (this.dialog) this.dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  PopupCarousel.prototype.onFocusIn = function (e) {
    if (!this.isOpen) return;
    if (!this.root.contains(e.target)) {
      var focusable = this.getFocusable();
      if (focusable.length) focusable[0].focus();
      else if (this.dialog) this.dialog.focus();
    }
  };

  PopupCarousel.prototype.open = function (trigger) {
    if (this.isOpen) return;
    this.lastTrigger = trigger || null;
    this.isOpen = true;
    this.root.hidden = false;
    this.root.classList.add('is-open');
    this.root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('popup-carousel-open');
    this.showCarousel(true);
    this.buildDots();
    this.syncNav();

    document.addEventListener('keydown', this.boundKeydown, true);
    document.addEventListener('focusin', this.boundFocusIn, true);

    var self = this;
    window.requestAnimationFrame(function () {
      if (self.dialog) self.dialog.focus();
    });
  };

  PopupCarousel.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.root.classList.remove('is-open');
    this.root.hidden = true;
    this.root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('popup-carousel-open');
    document.removeEventListener('keydown', this.boundKeydown, true);
    document.removeEventListener('focusin', this.boundFocusIn, true);

    var trigger = this.lastTrigger;
    this.lastTrigger = null;
    if (trigger && typeof trigger.focus === 'function') {
      trigger.focus();
    }
  };

  PopupCarousel.prototype.showCarousel = function (resetScroll) {
    if (this.carouselView) {
      this.carouselView.hidden = false;
      this.carouselView.classList.add('is-active');
    }
    if (this.detailView) {
      this.detailView.hidden = true;
      this.detailView.classList.remove('is-active');
    }

    this.root.querySelectorAll('[data-jsc-pc-select].is-active').forEach(function (btn) {
      btn.classList.remove('is-active');
    });

    if (resetScroll && this.track) {
      this.track.scrollLeft = 0;
      this.pageIndex = 0;
      this.syncDots(0);
    }
  };

  PopupCarousel.prototype.isBottlesMode = function () {
    return this.detailMode === 'compatible_bottles';
  };

  PopupCarousel.prototype.parseCompatibleBottles = function (btn) {
    var raw = btn.getAttribute('data-compatible-bottles');
    if (!raw) return [];
    try {
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      return [];
    }
  };

  PopupCarousel.prototype.renderBottlesDetail = function (machineTitle, bottles) {
    if (this.detailTitle) {
      this.detailTitle.textContent = String(this.detailHeadingPattern).replace(/\{machine\}/g, machineTitle);
    }

    if (this.detailImage) {
      this.detailImage.removeAttribute('src');
      this.detailImage.alt = '';
      this.detailImage.hidden = true;
    }
    if (this.detailImageWrap) this.detailImageWrap.hidden = true;
    if (this.cta) this.cta.hidden = true;

    if (this.bottleList) {
      this.bottleList.innerHTML = '';
      bottles.forEach(function (bottle) {
        var title = bottle && bottle.title ? String(bottle.title) : '';
        var url = bottle && bottle.url ? String(bottle.url).trim() : '';
        var hasUrl = url !== '' && url !== '#';
        var image = bottle && bottle.image ? String(bottle.image) : '';
        var imageAlt = bottle && bottle.image_alt ? String(bottle.image_alt) : title;

        var item = document.createElement('li');
        item.className = 'popup-carousel__bottle-item';

        var row = document.createElement(hasUrl ? 'a' : 'span');
        row.className = hasUrl
          ? 'popup-carousel__bottle-link'
          : 'popup-carousel__bottle-link popup-carousel__bottle-link--static';
        if (hasUrl) row.href = url;

        if (image) {
          var img = document.createElement('img');
          img.className = 'popup-carousel__bottle-image';
          img.src = image;
          img.alt = imageAlt;
          img.loading = 'lazy';
          row.appendChild(img);
        }

        var label = document.createElement('span');
        label.className = 'popup-carousel__bottle-title';
        label.textContent = title;
        row.appendChild(label);

        item.appendChild(row);
        this.bottleList.appendChild(item);
      }, this);

      this.bottleList.hidden = bottles.length === 0;
    }

    if (this.bottleEmpty) {
      this.bottleEmpty.hidden = bottles.length > 0;
    }
  };

  PopupCarousel.prototype.renderCylinderDetail = function (machineTitle, btn) {
    var productTitle = btn.getAttribute('data-product-title') || '';
    var productUrl = btn.getAttribute('data-product-url') || '#';
    var productImage = btn.getAttribute('data-product-image') || '';
    var productImageAlt = btn.getAttribute('data-product-image-alt') || productTitle;

    if (this.detailTitle) {
      this.detailTitle.textContent = '';
      this.detailTitle.appendChild(document.createTextNode(machineTitle + ' uses the '));
      var strong = document.createElement('strong');
      strong.textContent = productTitle;
      this.detailTitle.appendChild(strong);
    }

    if (this.detailImageWrap) this.detailImageWrap.hidden = false;

    if (this.detailImage) {
      if (productImage) {
        this.detailImage.src = productImage;
        this.detailImage.alt = productImageAlt;
        this.detailImage.hidden = false;
      } else {
        this.detailImage.removeAttribute('src');
        this.detailImage.alt = '';
        this.detailImage.hidden = true;
      }
    }

    if (this.cta) {
      this.cta.hidden = false;
      this.cta.href = productUrl;
    }

    if (this.bottleList) {
      this.bottleList.innerHTML = '';
      this.bottleList.hidden = true;
    }
    if (this.bottleEmpty) this.bottleEmpty.hidden = true;
  };

  PopupCarousel.prototype.showDetail = function (btn) {
    var machineTitle = btn.getAttribute('data-machine-title') || '';

    this.root.querySelectorAll('[data-jsc-pc-select].is-active').forEach(function (el) {
      el.classList.remove('is-active');
    });
    btn.classList.add('is-active');

    if (this.isBottlesMode()) {
      this.renderBottlesDetail(machineTitle, this.parseCompatibleBottles(btn));
    } else {
      this.renderCylinderDetail(machineTitle, btn);
    }

    if (this.carouselView) {
      this.carouselView.hidden = true;
      this.carouselView.classList.remove('is-active');
    }
    if (this.detailView) {
      this.detailView.hidden = false;
      this.detailView.classList.add('is-active');
      var back = this.detailView.querySelector('[data-jsc-pc-back]');
      if (back) back.focus();
    }
  };

  PopupCarousel.prototype.isDesktop = function () {
    return DESKTOP_MQ.matches;
  };

  PopupCarousel.prototype.getPageCount = function () {
    var count = this.items.length;
    if (!count) return 0;
    if (this.isDesktop()) {
      return Math.max(1, Math.ceil(count / PAGE_SIZE));
    }
    return count;
  };

  PopupCarousel.prototype.buildDots = function () {
    if (!this.dotsEl) return;
    this.dotsEl.innerHTML = '';

    if (this.isDesktop()) return;

    var pages = this.getPageCount();
    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'popup-carousel__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-jsc-pc-dot', '');
      dot.setAttribute('data-index', String(i));
      dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
      if (i === 0) dot.setAttribute('aria-current', 'true');
      this.dotsEl.appendChild(dot);
    }
  };

  PopupCarousel.prototype.syncDots = function (activeIndex) {
    if (!this.dotsEl) return;
    var dots = this.dotsEl.querySelectorAll('[data-jsc-pc-dot]');
    dots.forEach(function (dot, i) {
      var active = i === activeIndex;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  PopupCarousel.prototype.itemStep = function () {
    if (!this.items.length || !this.track) return 0;
    var first = this.items[0];
    var style = window.getComputedStyle(this.track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return first.getBoundingClientRect().width + gap;
  };

  PopupCarousel.prototype.scrollToItem = function (index, smooth) {
    if (!this.track || !this.items.length) return;
    var max = this.items.length - 1;
    index = Math.max(0, Math.min(index, max));
    var step = this.itemStep();
    var left = step * index;
    this.track.scrollTo({
      left: left,
      behavior: smooth && !prefersReducedMotion() ? 'smooth' : 'auto'
    });
    this.pageIndex = index;
    this.syncDots(index);
    this.syncNav();
  };

  PopupCarousel.prototype.goPage = function (direction) {
    if (!this.items.length) return;

    if (this.isDesktop()) {
      var pageCount = this.getPageCount();
      var next = this.pageIndex + direction;
      if (next < 0) next = pageCount - 1;
      else if (next >= pageCount) next = 0;
      this.pageIndex = next;
      this.scrollToItem(next * PAGE_SIZE, true);
      return;
    }

    var nextMobile = this.pageIndex + direction;
    if (nextMobile < 0 || nextMobile >= this.items.length) return;
    this.scrollToItem(nextMobile, true);
  };

  PopupCarousel.prototype.onTrackScroll = function () {
    if (!this.track || !this.items.length) return;
    var step = this.itemStep();
    if (!step) return;
    var index = Math.round(this.track.scrollLeft / step);
    index = Math.max(0, Math.min(index, this.items.length - 1));

    if (this.isDesktop()) {
      this.pageIndex = Math.floor(index / PAGE_SIZE);
    } else {
      this.pageIndex = index;
      this.syncDots(index);
    }
    this.syncNav();
  };

  PopupCarousel.prototype.syncNav = function () {
    if (!this.prevBtn || !this.nextBtn) return;

    if (this.isDesktop()) {
      this.prevBtn.hidden = this.items.length <= PAGE_SIZE;
      this.nextBtn.hidden = this.items.length <= PAGE_SIZE;
      this.prevBtn.disabled = false;
      this.nextBtn.disabled = false;
      return;
    }

    this.prevBtn.hidden = true;
    this.nextBtn.hidden = true;
  };

  function escapeClassName(name) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(name);
    return String(name).replace(/([^\w-])/g, '\\$1');
  }

  function onDocumentClick(e) {
    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.triggerClass) continue;
      var triggerEl = e.target.closest('.' + escapeClassName(inst.triggerClass));
      if (triggerEl) {
        e.preventDefault();
        inst.open(triggerEl);
        return;
      }
    }
  }

  function onDocumentKeydown(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target;
    if (!el || el === document.body) return;
    if (el.tagName === 'A' || el.tagName === 'BUTTON') return;

    for (var i = 0; i < instances.length; i++) {
      var inst = instances[i];
      if (!inst.triggerClass) continue;
      if (el.classList && el.classList.contains(inst.triggerClass)) {
        e.preventDefault();
        inst.open(el);
        return;
      }
    }
  }

  var documentListenersBound = false;

  function destroy() {
    instances.forEach(function (inst) {
      if (inst.isOpen) inst.close();
    });
    instances = [];
    if (documentListenersBound) {
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onDocumentKeydown);
      documentListenersBound = false;
    }
  }

  function init() {
    var roots = document.querySelectorAll('[data-jsc-popup-carousel]');
    roots.forEach(function (root) {
      instances.push(new PopupCarousel(root));
    });

    if (instances.length && !documentListenersBound) {
      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onDocumentKeydown);
      documentListenersBound = true;
    }
  }

  function remount() {
    destroy();
    init();
  }

  window.JSCPopupCarousel = {
    init: init,
    destroy: destroy,
    remount: remount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
